import { render, staticRenderFns } from "./SurveyResult.vue?vue&type=template&id=bcf50366&scoped=true"
import script from "./SurveyResult.vue?vue&type=script&lang=js"
export * from "./SurveyResult.vue?vue&type=script&lang=js"
import style0 from "./SurveyResult.vue?vue&type=style&index=0&id=bcf50366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf50366",
  null
  
)

export default component.exports